<template>

    <div>
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="{name:child.route}">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view></router-view>
    </div>

</template>

<script>

    import MenuItem from "../../Libraries/MenuItem";
    import FixedTabs from "../../Libraries/FixedTabs";

    export default {

        computed: {
            getMenu() {
                return [
                    new MenuItem('Facturatie (Projecten)', 'financial.invoiceschedule.index'),
                    new MenuItem('Facturatie (Niet-projecten)', 'financial.invoices.index'),
                    new MenuItem('Debiteurenbeheer', 'financial.openinvoices.index'),
                    new MenuItem('Begroting', 'financial.budgets.index'),
                    new MenuItem('Prognose', 'financial.prognosis.index'),
                    new MenuItem('Liquiditeit', 'financial.liquidity.index'),
                    new MenuItem('Nog te realiseren omzet', 'financial.toinvoice.index'),
                    new MenuItem('Statistieken', 'financial.stats.index'),
                ];
            }
        },

        destroyed(){
            FixedTabs.unset();
        },

        methods: {
            isActiveChildRoute(child) {
                return child.route === this.$route.name;
            },
        },

        mounted(){
            FixedTabs.set();
        },

        name:'FinancialLayout',

    }

</script>
